import PropTypes from 'prop-types';
import React from 'react';
import he from 'he';
import { Dropdown } from 'semantic-ui-react';
import { navigate } from 'gatsby-plugin-intl';
import { useTranslate } from 'react-polyglot';

import Config from '../../config';
import UserAvatar from '../content/UserAvatar/UserAvatar';
import { withFirebase } from '../../firebase';

import './AccountButton.scss';

const AccountButton = ({ firebase, user }) => {

  const t = useTranslate();

  const signout = async () => {
    if (firebase) {
      fetch(`${Config.parseServer.apiUrl}/log-auth`, {
        method: 'POST',
        body: JSON.stringify({
          uid: user.uid,
          event: 'signout',
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      await firebase.rtdb().goOffline();

      await firebase.doSignOut();
      navigate(Config.routePaths.landingPage);
    }
  };

  const goTo = (destination) => {
    navigate(destination);
  };

  const hasAClass = !!user && user.hasAClass;
  const hasAClassInProgress = !!user && user.classes && !!user.classes.inProgress && Object.keys(user.classes.inProgress).length > 0;
  const hasFullPass = !!user && user.isFullPassActive;

  return (
    <div className="menu-item">
      <Dropdown
        text={he.decode(user.firstName || '')}
        icon={<UserAvatar email={user.email} firstName={user.firstName} className="icon" />}
        direction="left"
        floating
        labeled
        button
        className="dropdown icon btn-account"
      >
        <Dropdown.Menu className="dropdown-menu">

          <Dropdown.Item text={t('common.allClasses')} onClick={() => goTo(`${hasAClass || hasFullPass || hasAClassInProgress ? Config.routePaths.dashboard : Config.routePaths.landingPage}#classes`)} className="desktop-hide tablet-hide-landscape lnk-all-classes" />

          {!hasFullPass && (
            <Dropdown.Item text={t('common.payment.passTitle')} onClick={() => goTo(Config.routePaths.pass)} className="desktop-hide tablet-hide-landscape lnk-account-support" />
          )}

          {(hasAClass || hasAClassInProgress) && (
            <Dropdown.Item text={t('common.myClasses')} onClick={() => goTo(Config.routePaths.myClasses)} className="desktop-hide tablet-hide-landscape lnk-account-support" />
          )}

          {hasFullPass && (
            <Dropdown.Item text={t('common.invite')} onClick={() => goTo(Config.routePaths.referralInvite)} className="lnk-referral-invite" />
          )}

          <Dropdown.Divider className="desktop-hide tablet-hide-landscape" />

          <Dropdown.Item text={t('common.settings.settings')} onClick={() => goTo(Config.routePaths.settings)} className="lnk-account-settings" />
          <Dropdown.Item text={t('common.signout')} onClick={signout} className="lnk-account-signout" />
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

AccountButton.propTypes = {
  firebase: PropTypes.any,
  user: PropTypes.object.isRequired,
};

AccountButton.defaultProps = {
  firebase: null,
};

export default withFirebase(
  AccountButton,
);
